import { useEffect, useState } from 'react';
import { getUserRoles } from '@routes/auth/___shared___/helpers.ts';

export function useUserRoles(): string[] {
    const [roles, setRoles] = useState<string[] | null>(getUserRoles());

    useEffect(() => {
        const handleStorage = (e: StorageEvent) => {
            if (e.key === 'accessToken') {
                setRoles(getUserRoles());
            }
        };
        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, []);

    return roles ?? [];
}
